export default __webpack_public_path__ + "static/media/logo.5ea622a3.png";